import Footer from '@components/Footer';
import Header from '@components/Header';
import HeaderInr from '@components/HeaderInr';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import DonationPopup from './DonationPopup';

const Layout = ({ isHomePage, children, anotherHeader }) => {
  // Title should be used for Seo
  // const {
  //   wp: {
  //     generalSettings: { title },
  //   },
  // } = useStaticQuery(graphql`
  //   query LayoutQuery {
  //     wp {
  //       generalSettings {
  //         title
  //         description
  //       }
  //     }
  //   }
  // `);

  useEffect(() => {
    const attemptScrollToHash = () => {
      const {hash} = window.location;
      const element = hash ? document.querySelector(`#${hash.slice(1)}`) : null;

      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      } else {
        window.scrollTo(0, 0);
      }
    };

    const timeout = setTimeout(() => {
      // Using requestAnimationFrame to ensure smooth scrolling
      requestAnimationFrame(attemptScrollToHash);
    }, 100); // Consider adjusting the timeout duration based on your needs

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className='' data-is-root-path={isHomePage}>
      <Helmet>
        <script>{
          `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          `
          }
          
        </script>
      </Helmet>
      <div className='canvas'>
        {anotherHeader === true ? (
          <HeaderInr isHomePage={isHomePage} />
        ) : (
          <Header isHomePage={isHomePage} />
        )}
        <main>{children}</main>
        <Footer />
        <DonationPopup />
      </div>
    </div>
  );
};

export default Layout;
